//
//
//
//
//
//
//
//
//

export default {
  name: 'App',
  mounted() {
    console.log(!this.$route.meta.keepAlive)
  }
};



// WEBPACK FOOTER //
// ./src/App.vue